import React, { useState } from "react";
import { Box, Button, TextField, Typography, Paper, CircularProgress } from "@mui/material";
import { loginAdmin } from "../services/api";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await loginAdmin(username, password);
      if (data.token) {
        onLogin(data.token);
      } else {
        setError(data.msg || "Σφάλμα!");
      }
    } catch (err) {
      setError("Σφάλμα δικτύου!");
    }
    setLoading(false);
  };


  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Paper sx={{ p: 4, minWidth: 340 }}>
        <Typography variant="h5" mb={3}>Admin Login</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Όνομα"
            value={username}
            onChange={e => setUsername(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
            required
          />
          <TextField
            label="Κωδικός"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
            required
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            type="submit"
            disabled={loading}
          >
            {loading ? <CircularProgress size={18} /> : "Σύνδεση"}
          </Button>
          {error && (
            <Typography color="error" mt={2}>{error}</Typography>
          )}
        </form>
      </Paper>
    </Box>
  );
}
